module.exports = {
  BASE_URL: "https://ceshi.qbbystudy.com",
};
//1